export const BASE_URL = "http://ec2-3-73-128-99.eu-central-1.compute.amazonaws.com"; //DEV

